module.exports = __webpack_public_path__ + "static/media/casa_giardino.f6fa0764.jpg";